import {PearlHarborGameAssets} from "../PearlHarborGameAssets";
import {TweenLite} from "gsap";
import {PearlHarbor} from "../PearlHarbor";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";

export class Multiplier extends PIXI.Container {
    private _multBg:PIXI.Sprite;
    private _multiplier:PIXI.BitmapText;
    private _multiplierValue:number = 0;

    constructor() {
        super();
        this.init();
    }

    get value():number {
        return this._multiplierValue;
    }

    set value(value:number) {
        if(value > 1) {
            this.playScaleAnim(value);
            this._multiplierValue = value;
            if(value > PearlHarbor.model.multiplierNextSpin) {
                debugger;
            }
            PearlHarborSoundManager.playBombMultiplierUpdate();
            this._multiplier.text = "x" + value.toString();
            this._multiplier.letterSpacing = value > 9 ? -7 : 0;
        } else {
            this._multiplier.text = "";
        }
    }

    public show():void {
        TweenLite.to(this._multiplier, 0.1, {alpha : 1});
    }

    public showLayer():void {
        this.visible = true;
    }

    public restore():void {
        this.show();
        this.value = PearlHarbor.model.multiplierNextSpin;
    }

    public hide():void {
        TweenLite.to(this._multiplier, 0.1, {
            alpha : 1, onComplete : () => {
                this.value = 0;
                this._multiplierValue = 0;
            }
        });
    }

    public reset():void {
        this.hide();
    }

    private init():void {
        this._multBg = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("multBackground")[0]);
        this._multBg.anchor.set(0.5);

        this._multiplier = new PIXI.BitmapText("", {
            fontName : PearlHarborGameAssets.BITMAP_FONT_MULTIPLIER,
            fontSize : 36
        });
        (<PIXI.Point>this._multiplier.anchor).set(0.5);
        this._multiplierValue = 0;
        this._multiplier.x = -15;
        this._multiplier.y = 0;

        this.addChild(this._multBg, this._multiplier);
        // this.value = 19;
    }

    private playScaleAnim(value:number):void {
        const toScale:number = (value > 4 ? 1.5 : 1.2); // #406
        TweenLite.to(this._multiplier.scale, 0.25, {
            x : toScale, y : toScale, onComplete : () => {
                TweenLite.to(this._multiplier.scale, 0.15, {x : 1, y : 1});
            }
        });
    }
}